// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fhHi","newExpiryDate":"styles_newExpiryDate__MUjiP","footer":"styles_footer__3phij"};